export enum EmployeeAppointmentSortOrderEnum {
    WebsiteOrder = 1,
    Invalid = 2, //will be treated as 3 when sorting
    Alphabetical = 3,
}
